import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ForumIcon from '@mui/icons-material/Forum';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import PieChartIcon from '@mui/icons-material/PieChart';
import PortraitIcon from '@mui/icons-material/Portrait';
import SettingsIcon from '@mui/icons-material/Settings';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import StorageIcon from '@mui/icons-material/Storage';
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import NotificationsIcon from '@mui/icons-material/Notifications';
import GroupIcon from '@mui/icons-material/Group';
import CreateShowcaseIcon from "../../sharedComponents/customIcons/CreateShowcaseIcon";

import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ContactSupportOutlinedIcon from "@mui/icons-material/ContactSupportOutlined";
import DashboardIcon from '@mui/icons-material/Dashboard';
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PaletteIcon from '@mui/icons-material/Palette';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import { FilterContext } from "../../common/FilterContext";
import Helper from '../../common/Helper';
import RouteConstants from "../../common/RouteConstants";

import { ChatBubbleOutlineOutlined, EventOutlined, VideoLibraryOutlined, VideogameAssetOutlined } from "@mui/icons-material";
import { AppDataContext } from '../../common/AppContext';
import { Role } from '../../helper';
import nbca from "../../images/nbca_logo.png";
import ActiveShowCaseDialog from "../../screens/other/ActiveShowCaseDialog";
import { userService } from '../../services';
import "./AppHeaderBar.css";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useProfileContext } from "../../common/ProfileContext";
import useTelemetry from '../../utils/useTelemetry';
import { ThemeContext } from "../../context/ThemeContext";

const useStyles = makeStyles((theme) => ({
  appBar: {
    color: theme.palette.header.text,
    backgroundColor:
      theme.palette.header.background,
  },
  list: {
    "&:focus": {
      outline: "none",
    },
  },
  title: {
    flexGrow: 1,
  },
  coachTitle: {
    cursor: 'pointer',
    color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.header.text,
  },
  headerTitle: {
    color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.header.text,
  },
  menu: {
    width: "250px",
  },
  itemIcon: {
    minWidth: "35px",
  },
  avatar: {
    backgroundColor: theme.palette.mode === 'dark'?  theme.palette.background.default : theme.palette.primary.main,
    color: "#ffffff",
  },
  coachAvatar: {
    backgroundColor: theme.palette.mode === 'dark'?  theme.palette.background.default : theme.palette.primary.main,
    cursor: 'pointer',
    color: "#ffffff",
  },
  version: {
    paddingLeft: theme.spacing(2),
  },
}));

const CONST_COACHES_COMMUNITY = "Coaches Community";

const AppHeaderBar = (props) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const [linkTextForProfile, setLinkTextForProfile] = useState();
  const [linkTextForProfileCoach, setLinkTextForProfileCoach] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showcaseDialog, setShowcaseDialog] = React.useState(false);
  const [showNotification, setShowNotification] = React.useState(false);
  const { mode, toggleTheme } = useContext(ThemeContext);
  const {
    canISeeCoachingTree
  } = useContext(AppDataContext);
  const open = Boolean(anchorEl);
  const userRole = userService.getUserRole();
  const { status } = useProfileContext();
  const { trackCustomEvents } = useTelemetry();

  useEffect(() => {
    setLinkTextForProfile(location.pathname === RouteConstants.DASHBOARD ? 'My Profile' : 'Back to Dashboard');
    setLinkTextForProfileCoach(location.pathname === RouteConstants.COACH_DASHBOARD ? 'My Profile' : 'Dashboard');
  }, [location.pathname]);

  useEffect(() => {
    if (userRole == Role.FrontOfficePlusCoach || userRole == Role.FrontOffice) {
      userService.getAllActiveShowCase()
        .then(data => {
          if (!data) {
            setShowNotification(false);
          }
          else {
            setShowNotification(true);
          }
        })
        .catch(err => {
          setShowNotification(false);
        })
    }
  }, []);


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    trackCustomEvents("ClickEvent", { event: "Menu" });
  };

  const handleShowcase = (event) => {
    setShowcaseDialog(true);
    trackCustomEvents("ClickEvent", { event: "Showcase" });
  };

  const handleSettings = (event) => {
    handleClose();
    navigate(RouteConstants.ADMIN_SETTINGS);
    trackCustomEvents("ClickEvent", { event: "Settings" });
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleThemeChange = () => {
    props.onThemeChange(props.currentThemeType === "dark" ? "light" : "dark");
  };

  function isUserOnLoginScreen() {
    if (
      location.pathname.toLowerCase() ===
      `${RouteConstants.COACH_LOGIN}`.toLowerCase()
    )
      return true;
    else return false;
  }

  function isUserOnsignUpScreen() {
    if (
      location.pathname.toLowerCase() ===
      `${RouteConstants.COACH_REGISTRATION}`.toLowerCase()
    )
      return true;
    else return false;
  }

  const handleSignInClick = () => {
    navigate(RouteConstants.COACH_LOGIN);
    trackCustomEvents("ClickEvent", { event: "Sign in" });
  };

  const handleRegistrationClick = () => {
    navigate(RouteConstants.COACH_REGISTRATION);
    trackCustomEvents("ClickEvent", { event: "Registration" });
  };

  const handleUpdateEmailClick = () => {
    handleClose();
    navigate(RouteConstants.COACH_CHANGE_EMAIL);
    trackCustomEvents("ClickEvent", { event: "Update Email" });
  };

  const handleSocialCommunityClick = () => {
    handleClose();
    navigate(RouteConstants.SOCIAL_COMMUNITY_CONTAINER);
    trackCustomEvents("ClickEvent", { event: "Coaches Community" });
    // setTabIndex(0);
    // setSkip(0);
  };

  const handleCalendarEventClick = () => {
    handleClose();
    navigate(RouteConstants.EVENT_CALENDAR);
    trackCustomEvents("ClickEvent", { event: "Event Calendar" });
    // setTabIndex(0);
    // setSkip(0);
  };

  const handleMyMemoClick = () => {
    handleClose();
    navigate(RouteConstants.COACH_VIEW_USER_MEMO);
    trackCustomEvents("ClickEvent", { event: "Memo" });
  };


  const handleChangePasswordClick = () => {
    handleClose();
    navigate(RouteConstants.COACH_CHANGE_PASSWORD);
    trackCustomEvents("ClickEvent", { event: "Change Password" });
  };

  const handleHelpDeskClick = () => {
    handleClose();
    navigate(RouteConstants.COACH_HELP_DESK);
    trackCustomEvents("ClickEvent", { event: "Help Desk" });
  };

  const handleFAQClick = () => {
    handleClose();
    navigate(RouteConstants.COACH_FAQ);
    trackCustomEvents("ClickEvent", { event: "FAQ" });
  };

  const handleToggleProfileAndDashboard = () => {
    handleClose();
    let pathname = RouteConstants.COACH_PROFILE_VIEW;
    if (location.pathname !== RouteConstants.DASHBOARD) {
      pathname = RouteConstants.DASHBOARD;
    }
    navigate(pathname);
    trackCustomEvents("ClickEvent", { event: "ProfileAndDashboard" });
  }

  const handleToggleCoachProfileAndDashboard = () => {
    handleClose();
    let pathname = RouteConstants.COACH_PROFILE_VIEW;
    if (location.pathname !== RouteConstants.COACH_DASHBOARD) {
      pathname = RouteConstants.COACH_DASHBOARD;
    }
    navigate(pathname);
    trackCustomEvents("ClickEvent", { event: "CoachProfileAndDashboard" });
  }

  const handleProfileViewCLick = () => {

    if (userRole === Role.Coach) {
      handleClose();
      navigate(RouteConstants.COACH_PROFILE_VIEW);
    }
    trackCustomEvents("ClickEvent", { event: "ProfileView" });

  }

  const { refreshFilterData } = useContext(FilterContext)
  const handleLogOut = () => {
    handleClose();
    refreshFilterData();
    navigate(RouteConstants.COACH_LOGOUT);
    trackCustomEvents("ClickEvent", { event: "Log Out" });
  }
  const handleDashboardClick = () => {
    handleClose();
    navigate(RouteConstants.DASHBOARD);
    trackCustomEvents("ClickEvent", { event: "Dashboard" });
  }
  const handleUserManagementClick = () => {
    handleClose();
    navigate(RouteConstants.USER_MANAGEMENT);
    trackCustomEvents("ClickEvent", { event: "User Management" });
  }

  const handleUserRoleClick = () => {
    handleClose();
    navigate(RouteConstants.USER_ROLE);
  }

  const handleInviteUserClick = () => {
    handleClose();
    navigate(RouteConstants.INVITE_USER);
    trackCustomEvents("ClickEvent", { event: "Invite User" });
  }

  const handleCoachesManagementClick = () => {
    handleClose();
    navigate(RouteConstants.COACH_MANAGEMENT);
    trackCustomEvents("ClickEvent", { event: "Coach Management" });
  };

  const handleAdminDashboardClick = () => {
    handleClose();
    navigate(RouteConstants.ADMIN_DASHBOARD);
    trackCustomEvents("ClickEvent", { event: "Admin Dashboard" });
  };
  const handleAdminMemoClick = () => {
    handleClose();
    navigate(RouteConstants.ADMIN_MEMO);
    trackCustomEvents("ClickEvent", { event: "Admin Memo" });
  };
  const handleAdminShowcaseClick = () => {
    handleClose();
    navigate(RouteConstants.ADMIN_SHOWCASE);
    trackCustomEvents("ClickEvent", { event: "Admin Showcase" });
  };
  const handleAdminGroupClick = () => {
    handleClose();
    navigate(RouteConstants.ADMIN_GROUP);
    trackCustomEvents("ClickEvent", { event: "Admin Group" });
  };

  const handleMediaManagementClick = () => {
    handleClose();
    navigate(RouteConstants.MEDIA_MANAGEMENT);
    trackCustomEvents("ClickEvent", { event: "Media Management" });
  };

  const closeShowcaseDialog = () => {
    setShowcaseDialog(false);
  };

  const handleAdminDataClick = () => {
    handleClose();
    navigate(RouteConstants.ADMIN_DATA);
  };

  return (
    <AppBar id="header" position="static" className={classes.appBar}>
      <Toolbar>
        {showcaseDialog && (<ActiveShowCaseDialog open={true} closeShowcaseDialog={closeShowcaseDialog}></ActiveShowCaseDialog>)}
        {/* <div className="appbar-nba-logo appbar-nba-logo-rightMargin"></div> */}
        <Typography variant="subtitle1" className={`${classes.title} headerTitle`}>
          <span className={userRole == Role.Coach ? classes.coachTitle : classes.headerTitle} onClick={handleProfileViewCLick} >NBA Coaches Database</span>
        </Typography>
        <div className="appbar-nba-logo appbar-nba-logo-rightMargin"></div>
        <div className="appbar-nba-logo-rightMargin nbcaLogo"><img src={nbca} />
        </div>
        {!isUserOnLoginScreen() && !isUserOnsignUpScreen() && (
          <div className="menuButtons">
            <IconButton
                aria-label={"Events"}
                aria-controls={"Events"}
                aria-haspopup="true"
                onClick={handleCalendarEventClick}
                color="inherit"
              >
                <Tooltip title={"Event Calendar"}>
                  <EventOutlined />
                </Tooltip>
              </IconButton>

            {(userRole == Role.Admin || (userRole == Role.Coach && status === "approved")) &&
              <IconButton
                aria-label={CONST_COACHES_COMMUNITY}
                aria-controls={CONST_COACHES_COMMUNITY}
                aria-haspopup="true"
                onClick={handleSocialCommunityClick}
                color="inherit"
              >
                <Tooltip title={CONST_COACHES_COMMUNITY}>
                  <ChatBubbleOutlineOutlined />
                </Tooltip>
              </IconButton>
            }
            {userRole == Role.Admin &&
              <IconButton
                aria-label="Settings"
                aria-controls="Settings"
                aria-haspopup="true"
                onClick={handleSettings}
                color="inherit"
              ><Tooltip title="Settings">
                  <SettingsIcon /></Tooltip>
              </IconButton>
            }
            {showNotification &&
              <Tooltip title="Current Coach Showcase">
                <IconButton
                  aria-label="Showcase"
                  aria-controls="ShowCase"
                  aria-haspopup="true"
                  onClick={handleShowcase}
                  color="inherit"
                >
                  <CreateShowcaseIcon />
                </IconButton></Tooltip>
            }
            {!props.onlyHeader &&
              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            }
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              <List className={classes.list}>
                <ListItem
                  className={classes.menu}
                  style={{ paddingBottom: "20px" }}
                >
                  <ListItemAvatar>
                    <Avatar onClick={handleProfileViewCLick} className={userRole === Role.Coach ? classes.coachAvatar : classes.avatar}>{Helper.GetNameInitials(userService.getUserFullName())}</Avatar>
                  </ListItemAvatar>
                  <ListItemText id="user-name" primary={userService.getUserFullName()} />
                </ListItem>

                <Divider></Divider>
                {/* <ListItem className={classes.menu}>
                  <ListItemIcon className={classes.itemIcon}>
                    <Brightness4OutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText id="dark-theme" primary="Dark Mode" />
                  <ListItemSecondaryAction>
                    <Switch
                      edge="end"
                      onChange={handleThemeChange}
                      checked={props.currentThemeType === "dark"}
                      inputProps={{ "aria-labelledby": "switch-dark-theme" }}
                    />
                  </ListItemSecondaryAction>
                </ListItem> */}
                {userRole == Role.FrontOfficePlusCoach && linkTextForProfile &&
                  <>
                    <MenuItem onClick={handleToggleProfileAndDashboard}>
                      <ListItemIcon className={classes.itemIcon}>
                        {location.pathname !== RouteConstants.DASHBOARD &&
                          <DashboardIcon fontSize="small" />
                        }
                        {location.pathname === RouteConstants.DASHBOARD &&
                          <AccountCircle fontSize="small" />
                        }
                      </ListItemIcon>
                      <ListItemText primary={linkTextForProfile} />
                    </MenuItem>
                  </>
                }

                {userRole == Role.Coach && linkTextForProfileCoach && canISeeCoachingTree != undefined && canISeeCoachingTree === 'true' &&
                  <>
                    <MenuItem onClick={handleToggleCoachProfileAndDashboard}>
                      <ListItemIcon className={classes.itemIcon}>
                        {location.pathname !== RouteConstants.COACH_DASHBOARD &&
                          <DashboardIcon fontSize="small" />
                        }
                        {location.pathname === RouteConstants.COACH_DASHBOARD &&
                          <AccountCircle fontSize="small" />
                        }
                      </ListItemIcon>
                      <ListItemText primary={linkTextForProfileCoach} />
                    </MenuItem>
                  </>
                }

                {userRole == Role.FrontOffice &&
                  <>
                    <MenuItem onClick={handleDashboardClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <DashboardIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Dashboard" />
                    </MenuItem>
                  </>
                }
                {(userRole == Role.Admin) &&
                  <>
                    <MenuItem onClick={handleAdminDashboardClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <PieChartIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Coach Analytics" />
                    </MenuItem>
                    <MenuItem onClick={handleUserManagementClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <PortraitIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="User Management" />
                    </MenuItem>
                    <MenuItem onClick={handleCoachesManagementClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <SportsBasketballIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Coaches Management" />
                    </MenuItem>
                    <MenuItem onClick={handleMediaManagementClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <VideoLibraryOutlined fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Media Management" />
                    </MenuItem>
                    <MenuItem onClick={handleInviteUserClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <InsertInvitationIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Invite User" />
                    </MenuItem>
                    <MenuItem onClick={handleAdminMemoClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <ForumIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Manage Memos" />
                    </MenuItem>
                    <MenuItem onClick={handleAdminShowcaseClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <CreateShowcaseIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Manage Showcase" />
                    </MenuItem>
                    <MenuItem onClick={handleAdminGroupClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <GroupIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Manage Groups" />
                    </MenuItem>
                    <MenuItem onClick={handleAdminDataClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <StorageIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="Manage Data" />
                    </MenuItem>
                  </>
                }
                {(userRole == Role.FrontOffice || userRole == Role.Coach || userRole == Role.FrontOfficePlusCoach)
                  &&
                  <>
                    <MenuItem onClick={handleMyMemoClick}>
                      <ListItemIcon className={classes.itemIcon}>
                        <AccountCircle fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary="My Memos" />
                    </MenuItem>
                  </>
                }
                <MenuItem onClick={handleUpdateEmailClick}>
                  <ListItemIcon className={classes.itemIcon}>
                    <EmailOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Update Email" />
                </MenuItem>

                <MenuItem onClick={handleChangePasswordClick}>
                  <ListItemIcon className={classes.itemIcon}>
                    <VpnKeyOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Change Password" />
                </MenuItem>

                <MenuItem onClick={handleHelpDeskClick}>
                  <ListItemIcon className={classes.itemIcon}>
                    <ContactSupportOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Help Desk" />
                </MenuItem>

                <MenuItem onClick={handleFAQClick}>
                  <ListItemIcon className={classes.itemIcon}>
                    <LiveHelpOutlinedIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="FAQ" />
                </MenuItem>


                <MenuItem onClick={toggleTheme}>
                  <ListItemIcon className={classes.itemIcon}>
                    <PaletteIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={mode === 'dark'? "Light Mode" : "Dark Mode"} />
                </MenuItem>

                <MenuItem onClick={handleLogOut}>
                  <ListItemIcon className={classes.itemIcon}>
                    <ExitToAppIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Log out" />
                </MenuItem>
              </List>
              <Divider></Divider>
              {/* <ListItemText
                className={classes.version}
                primary={
                  <Typography variant="caption">
                    version: 0.0.8754.4543
                  </Typography>
                }
              /> */}
            </Menu>
          </div>
        )}
        {isUserOnLoginScreen() && (
          <Button color="inherit" onClick={handleRegistrationClick}>
            Sign Up
          </Button>
        )}
        {isUserOnsignUpScreen() && (
          <Button color="inherit" onClick={handleSignInClick}>
            Login
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default AppHeaderBar;
